export default __webpack_public_path__ + "static/media/oceandoor_complete.ebcf46e0.jpeg";